<template>
  <LazyBlogPageLayout hydrate-on-idle path="faq">
    <template #default="{ data }">
      <SchemaFaqContent :data="data" />
    </template>
  </LazyBlogPageLayout>
</template>
